export const RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT =
  'RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT' as const

export interface ResetDeactivateVirtualCardContentAction {
  type: typeof RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT
}

// Reset the slice to its initial state. Dispatched when the deactivate modal
// mounts so a re-opened modal never inherits the loading/error left behind by a
// previously-opened card whose request was abandoned (modal closed mid-flight).
export const resetDeactivateVirtualCardContent =
  (): ResetDeactivateVirtualCardContentAction => ({
    type: RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT,
  })
